import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog'; // kitlint-allow-material: opened by the shared PayableActionsService, whose callers live outside payables-dashboard
import moment from 'moment-timezone';
import { CommonModule } from '@angular/common';
import { LegfiCurrencyPipe } from 'app/pipes/format/legfi-currency.pipe';
import { LegfiDatePipe } from 'app/pipes/format/legfi-date.pipe';

export interface PayableApprovalDecisionDialogInput
{
    title?: string;
    buttonText?: string;
    payableId?: number;
    vendorName: string;
    invoiceTotal: number;
    paymentAmount: number;
    scheduledPaymentDate?: moment.Moment;
}

export interface PayableApprovalDecisionDialogResult
{
    success: boolean;
}

@Component({
    selector: 'app-approve-payable-dialog',
    templateUrl: './approve-payable-dialog.component.html',
    styleUrls: ['./approve-payable-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LegfiCurrencyPipe,
        LegfiDatePipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApprovePayableDialogComponent
{

    constructor(
            public _dialogRef: MatDialogRef<ApprovePayableDialogComponent>, // kitlint-allow-material: opened by the shared PayableActionsService, whose callers live outside payables-dashboard
            @Inject(MAT_DIALOG_DATA) public data: PayableApprovalDecisionDialogInput, // kitlint-allow-material: opened by the shared PayableActionsService, whose callers live outside payables-dashboard
    ) {
        this._dialogRef.addPanelClass('kit-dialog');
    }

    confirmDecisionAction() {
        return this._dialogRef.close(<PayableApprovalDecisionDialogResult>{
            success: true,
        });
    }
}
